<template>
  <div>
    <NavBar/>
    <div class="workspaces">
      <div>
        <div class="container" v-if="workspaces">
          <div class="row">


              <div class="col-sm-2" v-if="!fbUser.inviteDisabled">
                <button @click.prevent="showPrompt()" class="btn btn-success m-1">Add Canvas</button>
              </div>

            <div >
               <div class="col-sm">
                <b-form-group  >



                  <b-form-input v-model='search'  placeholder="Search"></b-form-input>

                  <b-form-checkbox
                      id="checkbox-1"
                      v-model='showDeleted'
                      name="showDeleted"
                      value="deleted"
                      unchecked-value="invited"
                    >
                      Show Deleted
                    </b-form-checkbox>




                </b-form-group>
                  </div>
                </div>

              </div>


          <div class="row">

            <template  v-for="(workspace, key) in   filterBy(workspaceWithDates, search, 'name')  "  >
              <div v-if='workspace.userEmail != fbUser.email && (workspace.status =="invited"   || workspace.status ==showDeleted  )   ' class="col-sm-3">
                <div class="card">
                  <div style="padding:none" class="card-header">
                    <span class="small badge-pill badge-success float-right" >
                             Updated
                    </span>
                    </div>

                  <div class="card-body">

                      <button
                       v-if="workspace.status=='invited' "
                        @click='deleteWorkspace(workspace.fbKey, workspace.name)'
                        style='position:absolute;top:0px;right:0px'

                         type="button" class="btn btn-warning btn-sm m-1">X</button>

                      <button v-if="workspace.status=='deleted' "
                       @click='restoreWorkspace(workspace.fbKey, workspace.name)'
                        style='position:absolute;top:0px;right:0px'
                         type="button" class="btn btn-warning btn-sm m-1">
                         <icon name="undo" />

                         </button>






                    <h5 class="card-title h3 mb-4">{{ workspace.name }} </h5>
                    <a
                      href="#"
                      @click.prevent="chooseWorkspace(workspace.id, workspace.name)"
                      class="btn btn-primary"
                    >Select Canvas</a>


                  </div>
                                  <span v-if='workspace.lastUpdate' class="small " >
                                    {{ workspace.lastUpdate  | moment("MMM Do, h:mm")}} - {{ workspace.userEmail }}</span>

                </div>


              </div>
            </template>



            <template  v-for="workspace in  filterBy(workspaceWithDates, search, 'name')"  >
              <div v-if='workspace.userEmail == fbUser.email && (workspace.status =="invited"  || workspace.status ==showDeleted  ) ' class="col-sm-3">
                <div class="card">

                  <div class="card-body">

                      <button
                       v-if="workspace.status=='invited' "
                        @click='deleteWorkspace(workspace.fbKey, workspace.name)'
                        style='position:absolute;top:0px;right:0px'

                         type="button" class="btn btn-warning btn-sm m-1">X</button>

                      <button v-if="workspace.status=='deleted' "
                       @click='restoreWorkspace(workspace.fbKey, workspace.name)'
                        style='position:absolute;top:0px;right:0px'
                         type="button" class="btn btn-warning btn-sm m-1">
                         <icon name="undo" />

                         </button>



                    <h5 class="card-title h3 mb-4">{{ workspace.name }}  </h5>
                    <a
                      href="#"
                      @click.prevent="chooseWorkspace(workspace.id, workspace.name)"
                      class="btn btn-primary"
                    >Select Canvas</a>


                  </div>
                                  <span v-if='workspace.lastUpdate' class="small  " >
                                    {{ workspace.lastUpdate  | moment("MMM Do, h:mm")}} - {{ workspace.userEmail }}</span>

                </div>


              </div>
            </template>




          </div>


          <div class="row">
            <template v-for="workspace in  filterBy(workspaceArray, search, 'name')"  >
              <div  class="col-sm-3" v-if='!workspace.lastUpdate  &&  (workspace.status =="invited"  || workspace.status ==showDeleted )  '>
              <div :key="workspace.id"   class="card">

                <div class="card-body">



                      <button
                       v-if="workspace.status=='invited' "
                        @click='deleteWorkspace(workspace.fbKey, workspace.name)'
                        style='position:absolute;top:0px;right:0px'

                         type="button" class="btn btn-warning btn-sm m-1">X</button>

                      <button v-if="workspace.status=='deleted' "
                      @click='restoreWorkspace(workspace.fbKey, workspace.name)'
                        style='position:absolute;top:0px;right:0px'
                         type="button" class="btn btn-warning btn-sm m-1">
                         <icon name="undo" />

                         </button>


                  <h5 class="card-title h3 mb-4">{{ workspace.name }} </h5>
                  <a
                    href="#"
                    @click.prevent="chooseWorkspace(workspace.id, workspace.name)"
                    class="btn btn-primary"
                  >Select Canvas</a>


                </div>
                                <span v-if='workspace.lastUpdate' class="small badge-pill badge-success " >
                                  {{ workspace.lastUpdate  | moment("MMM Do, h:mm")}} - {{ workspace.userEmail }}</span>

              </div>

              </div>
            </template>
          </div>

          <div v-if="isUserManager" class="row">





            <h2>

              Manager invitation:<br>
            Enter the list of email addresses below, one per line.<br>
              Each user will get their own canvas setup and can then invite other users to their canvas via the standard invite tab.
            </h2>
            <textarea class='form-control' rows=9 v-model='inviteText'>


            </textarea>
            <div style='padding-bottom:200px' class='float-right  py-2'>
            <button


             @click='inviteManagerEmails(inviteText,managerEmailTemplate);inviteText=" ",
              showAlert("Thank you, your invites have been sent.")' class='btn btn-success'  >Send Invites</button>
            </div>





          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// components
import NavBar from '@/components/NavBar'
// services
import db from '@/services/db'
import auth from '@/services/auth'



const $ = window.$

export default {
  components: {
    NavBar
  },
  data () {
    return {
      chosen: null,
      workspaces: null,
      workspaceArray:[],
      customCode: null,
      fbUser: fbUser,
      inviteText: null,
      showDeleted:'invited',
      search: '',
      inviteDisabled:false
    }
  },



  computed: {
    ...mapState([
      'currentDash',
      'userId'
    ]),
    isUserManager () {
      return this.$can('manageUsers', 'Dashboard_' + this.currentDash)
    },
      managerEmailTemplate: function () {
            var a = 'Dear Ingenuity Seeker  <br><br>' +

                    'Welcome to the Ingenuity Canvas. You’ve just taken an important step to increase your creative-solution making. <br><br>  '+

                    'Whether you use the Ingenuity Canvas yourself or with a team, the toolset can guide you to more ingenious execution.  <br><br> '+


                    'Click the link below to sign up. Pull up a Canvas and let the ingenuity begin.  <br><br>' +

                    'IMPORTANT: Please sign up using the same email address that this invitation was sent to.  <br><br>' +

                    'https://ingenuity.tangleapps.com <br><br>' +

                    'Here’ s to ingenuity, <br><br>' +

                    'Dave <br><br> ' +

                    'Dave Fleming <br> ' +
                    'The Ingenuity Lab <br> ' +
                    'Founder / CEO '

            return a
          },


     workspaceWithDates: function() {
        var wsa = this.workspaceArray;
        return this.workspaceArray.filter(function(el) {
            return el.lastUpdate;
        })
     }
  },

beforeCreate: function() {
  if (!fbUser) {
        console.log('user not authorized send to auth page')
        this.$router.push('/auth')
      }

}
,

  methods: {

      inviteManagerEmails(emailList, template) {
         var emailList = this.inviteText.split("\n")
          //loop over email
          var inviteObj = {}
          var _this = this

          // make sure its a real email
          emailList.forEach(function (entry) {
            _this.addManagerWorkspace(entry.trim(), entry.trim(), template)


          });


        },
        addManagerWorkspace(name, email, template) {
          // add canvas to canvas list and get its guid using
          // Generate a reference to a new location and add some data using push()
          var dbref = db.getDBRef('access/workspaces', true).push()
          email = email.toLowerCase()
          // Get the unique key generated by push()
          var workspaceKey = dbref.key

          var newWorkspace = {
            dashboard: `${this.$route.params.id}`,
            owner: window.fbUser.uid,
            name: name
          }

          dbref.update(newWorkspace)

          var inviteKey =
            workspaceKey + '-' + email.replace(/[.]/g, '!').toLowerCase()

          var newInvite = {
            [inviteKey]: {
              email: email,
              status: 'invited',
              id: workspaceKey,
              name: name,
              template: template
            }
          }

          db.getDBRef('access/workspaceAccess', true)
            .update(newInvite)

          //now make an invite for person who sent the invite
            var inviteKey =
              workspaceKey + '-' + window.fbUser.email.replace(/[.]/g, '!')

            var newInvite = {
              [inviteKey]: {
                email: window.fbUser.email,
                status: 'invited',
                id: workspaceKey,
                name: name,
                template: template
              }
            }

            db.getDBRef('access/workspaceAccess', true)
              .update(newInvite)







        },

    showAlert: (message) => {
      alert(message)
    },
    deleteWorkspace: (key, name) => {
      var del = confirm('Are you sure you want to delete the workspace ' + name)
      if (del) {
        console.log('Deleting workspace ' + key);

        var dbref = db.getDBRef('access/workspaceAccess/' + key, true)
        dbref.update({status:'deleted'})
       //var dbref = db.getDBRef('access/workspaceAccess', true).push()
       // window.location.reload();
      }


    },
        restoreWorkspace: (key, name) => {
      var del = confirm('Are you sure you want to restore the workspace ' + name)
      if (del) {
        console.log('Restoring workspace ' + key);

        var dbref = db.getDBRef('access/workspaceAccess/' + key, true)
        dbref.update({status:'invited'})
       //var dbref = db.getDBRef('access/workspaceAccess', true).push()
       window.location.reload();
      }


    },
    showPrompt () {
      const options = { title: 'Enter a unique, descriptive name for this canvas', okLabel: 'Continue' }
      this.$dialogs
        .prompt('', options)
        .then(res => {
          if (res.ok) {
            this.addWorkspace(res.value)
          }
        })
    },
    chooseWorkspace (chosen, name) {
      this.chosen = chosen
      localStorage.workspace = chosen
      localStorage.workspaceName = name
      fbUser.workspace = chosen
      fbUser.workspaceName = name
      console.log('ws name is' + name)

      this.$router.push(`/dashboard/${this.$route.params.id}`)
    },
    addWorkspace (name) {
      // add canvas to canvas list and get its guid using
      // Generate a reference to a new location and add some data using push()
      var dbref = db.getDBRef('access/workspaces', true).push()

      // Get the unique key generated by push()
      var workspaceKey = dbref.key

      var newWorkspace = {
        dashboard: `${this.$route.params.id}`,
        owner: window.fbUser.uid,
        name: name
      }

      dbref.update(newWorkspace)

      var inviteKey =
        workspaceKey + '-' + window.fbUser.email.replace(/[.]/g, '!')

      var newInvite = {
        [inviteKey]: {
          email: window.fbUser.email,
          status: 'invited',
          id: workspaceKey,
          name: name,
          template: 'this is my test email'
        }
      }

      db.getDBRef('access/workspaceAccess', true)
        .update(newInvite)

      localStorage.workspace = workspaceKey
      localStorage.workspaceName = name
      this.$router.push(`/dashboard/${this.$route.params.id}`)


    },
    fillCss () {
      if (!this.customCode || !this.customCode.css) return

      let cssCode = ''

      if (this.customCode.css) {
        let css = this.customCode.css
        for (let key in css) {
          if (css[key].scope) continue

          cssCode += css[key].code + '\n'
        }
      }

      if (this.customCode.css) {
        let css = this.customCode.css
        for (let key in css) {
          if (!css[key].scope || css[key].scope !== this.scope) continue

          cssCode += css[key].code + '\n'
        }
      }

      $('body').append(`<style class="customCssCode">${cssCode}</style>`)
    }
  },
  async created () {
    const dashId = this.$route.params.id
    this.$store.commit('setCurrentDash', dashId)



    $('document').ready(function (){
        $('.appNav__logo a').contents().unwrap();
    })

    await new Promise((resolve) => {
      db.access.dashboard(this.userId, this.currentDash, (actions) => {
        if (!actions) {
          resolve()
          return
        }
        let rule = this.$buildACLRule('Dashboard_' + this.currentDash, actions)
        this.$store.commit('updateCaslRules', rule)
        resolve()
      })
    })

    //does user have any workspaces at all?
    await new Promise(resolve => {
      this.workspaces = []
      var _this = this

      if (fbUser){
        console.log('check if user can access any workspaces and send to auth if not')
        console.log(window.fbUser.email)
        window.fbUser.email
        db.accessRef
          .child('workspaceAccess')
          .orderByChild('email')
          .equalTo(window.fbUser.email)
          .once('value').then(function(snapshot) {
            var ws = snapshot.val()
            var inviteDisabled = false
            if (!snapshot.val()){
              console.log('User has no workspaces log them out')
              auth.signOut(_this.isUserAnonymous, _this.userId, (err) => {
                _this.$store.commit('markUserAsAnonymous', false)
                _this.$store.commit('destroyCasl')
                  _this.$router.push('/auth')
                  _this.$store.commit('setDashboardLoadingStatus', false)
              }
              )
            } else {
              console.log('User has some workspace send to seleciton page')
              ws = snapshot.val()
              Object.keys(ws).forEach(function(key) {
                ws[key].fbKey = key

                //if user is not inviteDisabled on any workspace then give permissions
                if (ws[key].disableInvites  == 'true'){
                  fbUser.inviteDisabled = true
                }


              })



            }


          resolve()
          return
        })

      }
    })

    await new Promise(resolve => {
      this.workspaces = []
      if (fbUser) {
        db.accessRef
          .child('workspaceAccess')
          .orderByChild('email')
          .equalTo(window.fbUser.email)
          .once('value', snapshot => {
            var ws = snapshot.val()

            this.workspaces = ws

            resolve()
          })
      }


    })

    if (fbUser) {
       await new Promise(resolve => {
        this.workspaceUpdate = {}
        db.accessRef
          .child('workspaceUpdates')
          .on('child_added', snapshot => {
            this.workspaceUpdate = snapshot.val()
            if (snapshot.val()){
              //console.log(this.workspaceUpdate)
              var k = snapshot.key
              var email = fbUser.email.replace(/[.]/g, '!')

              var objkey = k + '-' + email

              //console.log(k + 'key is '+objkey);

              if (this.workspaces[objkey]) {
                this.workspaces[objkey].lastUpdate = this.workspaceUpdate.lastUpdate
                this.workspaces[objkey].userEmail = this.workspaceUpdate.userEmail
                this.workspaces[objkey].fbKey =     objkey

              }


              this.workspaceArray = _.sortBy(_.toArray(this.workspaces), 'lastUpdate').reverse();
            }


            resolve()
          })
      })



    }


    await new Promise((resolve) => {
      db.settings.read(this.currentDash, (settings) => {
        this.$store.commit('setSettings', settings || {})
        resolve()
      })
    })

    await new Promise((resolve) => {
      db.customCode.read((customCode) => {
        $('.customCssCode').remove()
        this.customCode = customCode
        this.fillCss()
        resolve()
      })
    })

    this.$store.commit('setDashboardLoadingStatus', false)
  },
  beforeDestroy () {
    $('.customCssCode').remove()
    this.$store.commit('setSettings', {})
  }
}
</script>

<style lang="scss">
.workspaces {
  height: calc(100vh - 60px);
  padding: 10px;
  padding-bottom: 300px;
  overflow-x: auto;
  &__backLink span {
    vertical-align: -2px;
  }
  &__hr {
    margin: 10px 0;
  }
}
</style>
